import { makeRequest } from '../../helpers/requestHelpers';
import baseParams from './config';

const getAuthorizationToken = async (body, { onError, onSuccess }) => {
  return makeRequest(`${process.env.ACCOUNT_SERVICE_URL}/api/v1/oauth/token`, {
    body: { ...body, ...baseParams, grant_type: 'authorization_code' },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    requestType: 'POST',
    onSuccess,
    onError,
  });
};

export default getAuthorizationToken;
